import { render, staticRenderFns } from "./mdi-clipboard-list-outline.vue?vue&type=template&id=b06865d6&"
import script from "./mdi-clipboard-list-outline.vue?vue&type=script&lang=js&"
export * from "./mdi-clipboard-list-outline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b06865d6')) {
      api.createRecord('b06865d6', component.options)
    } else {
      api.reload('b06865d6', component.options)
    }
    module.hot.accept("./mdi-clipboard-list-outline.vue?vue&type=template&id=b06865d6&", function () {
      api.rerender('b06865d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/mdi-clipboard-list-outline.vue"
export default component.exports